import { __generator } from "tslib";
import { all, take, call, put, takeEvery } from 'redux-saga/effects';
import { request } from '../../../xhr';
import { actions as modalActions } from '../../../Modals';
import { ModalType } from '../../../Modals/redux/types';
import { reduxModuleLoaded, createTipJarTier } from './actions';
function handleCreateTipJarTier() {
    var data, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = {
                    title: 'Tip Jar',
                    description: "Support my work by contributing to my tip jar. This tier won't include any specific perks, but you will receive my appreciation.",
                    price: 1,
                    display_num_subscribers: false,
                    benefits: ['Support my art', 'Earn my gratitude'],
                    tags: ['tipjar', 'tip'],
                    access_settings: 'all',
                    thank_message_title: 'Thanks for the tip!',
                    thank_message_body: 'Every dollar goes toward helping me develop as an artist. I really appreciate your contribution.',
                    cover_image_deviation_id: 902857689,
                    is_mature: false,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/tier/create',
                        data: data,
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, put(modalActions.pushModal(ModalType.TIER_EDIT, {
                        wrapInModal: false,
                        params: response,
                    }))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default function userTiersSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, take(reduxModuleLoaded)];
            case 1:
                _a.sent();
                return [4 /*yield*/, all([takeEvery(createTipJarTier, handleCreateTipJarTier)])];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=tipJarSaga.js.map